const EXTRANET_GROUPS = [
  'extranet_CoDi',
  'extranet_GeOp',
  'extranet_Supervisor',
  'extranet_Cliente'
]

const SUPPLIER_GROUPS = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras',
  'DesProveedores',
  'CoDiProveeduria',
  'GeLogistica'
]

const SUPPLIER_GROUPS_LOW_TIER = [
  'AuxClara',
  'AuxCxP',
  'AuxCompras'
  // 'Desarrollador Proveedores'
]

export { EXTRANET_GROUPS, SUPPLIER_GROUPS, SUPPLIER_GROUPS_LOW_TIER }
